import { Accordion } from './lib/accordion.js';
import { AccordionItem } from './lib/accordion-item.js';
customElements.define('cipublic-accordion', Accordion);
customElements.define('cipublic-accordion-item', AccordionItem);
//# sourceMappingURL=cipublic-accordion.js.map